import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { CountersService } from '../counters.service';
import { ICounter } from '../counters.interface';
import { AuthService } from '../../../../shared/services/auth.service';
import { AlertService } from '../../../../shared/services/alert.service';

let self: any;

@Component({
  selector: 'app-counters-modal',
  templateUrl: './counters-modal.component.html',
  styleUrls: ['./counters-modal.component.css']
})
export class CountersModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;
  counter!: ICounter;
  action: string = '';

  constructor(
    public _CountersService: CountersService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService,
    private alertService: AlertService,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    if (this.counter !== undefined) {
      this.action = 'Modificar';
      this.getCounters();
    }
    else {
      this.action = 'Crear';
      this.buildForm();
    }
    this.form.valueChanges.subscribe(() => {
      this.updateMatHint();
    });
  }

  getCounters() {
    this.loading = true;
    this._CountersService.getCounter(this.counter._id || '').subscribe((counter) => {
      this.counter = counter
      //console.log(counter)
      //console.log(this.counter)
      this.buildForm();
      this.loading = false;
    });
  }

  updateMatHint() {
    const serie = this.form.get('reference_value.serie')?.value || 'X'; // Valor predeterminado si el campo serie está vacío
    const seq = this.form.get('seq')?.value;

    // Ajustar el número para que siempre tenga cuatro dígitos
    const paddedSeq = this.padNumber(seq + 1, 4);

    // Actualizar el mat-hint con el nuevo valor formateado
    const matHintElement = document.querySelector('.mat-hint');
    if (matHintElement) {
      matHintElement.textContent = `La próxima factura será la ${serie}-${paddedSeq}`;
    }
  }

  padNumber(num: number, size: number): string {
    let numString = num.toString();
    while (numString.length < size) {
      numString = '0' + numString;
    }
    return numString;
  }

  get f() { return this.form.controls; }
  buildForm() {
    const id = this.counter ? this.counter.id || 'billing_counter' : 'billing_counter';
    const company = this.counter && this.counter.reference_value ? this.counter.reference_value.company || '' : '';
    const serie = this.counter && this.counter.reference_value ? this.counter.reference_value.serie || '' : '';
    const seq = this.counter && this.counter.seq ? this.counter.seq : 0;

    this.form = this.fb.group({
      id: [id],
      reference_value: this.fb.group({
        company: [company],
        serie: [serie, Validators.required]
      }),
      seq: [seq],
    });
  }

  get serieControl(): FormControl {
    return this.form.get('reference_value.serie') as FormControl;
  }
  
  get seqControl(): FormControl {
    return this.form.get('seq') as FormControl;
  }

  setEditable() {
    this.readOnly = false;
  }

  onSubmit() {
    this.submitted = true;
    let data: any = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    data.reference_value.company = this._AuthService.companyId();
    this._CountersService.createCounter(data).subscribe({
      next: (counter) => {
        this.dialog.close(counter);
      },
      error: error => {
        console.log(error)
        this.loading = false;
        if (error.error.message.includes("Counter exists in db")) {
          this.alertService.error('Ya existe una serie con ese nombre');
          this.saving = false;
        } else {
          this.alertService.error('¡Ups! Ha ocurrido un error inesperado. Por favor, contacta al soporte.');
        }
      }
    });
    // if (!this.counter._id) {
    //     // data._id = this.counter._id;
    //     // this._CountersService.updateCounter(data).subscribe((counter) => {
    //     //     this.dialog.close(counter);
    //     // });
    //     this.dialog.close();
    // } else {
    //     this._CountersService.createCounter(data).subscribe({
    //         next: (counter) => {
    //           this.dialog.close(counter);
    //         },
    //         error:error => {
    //     console.log(error)
    //     if (error.error.message.includes("Algo no salio bien")) {
    //       this.alertService.error('Ya existe una serie con ese nombre');
    //     } else {
    //       this.alertService.error('¡Ups! Ha ocurrido un error inesperado. Por favor, contacta al soporte.');
    //     }
    //   }
    //       });
    // }
  }
}